import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ToolSetRadioGroup, ToolSetRadioItem } from '../../../../../components/ToolSet';
import { injectIntl } from 'react-intl';
import messages from '../../../../../utils/translationMessages';
import { generateSearchPath } from '../../../../../utils/urlHelpers/boats';
import Link from '../../../../../components/SEO/Link';

class FilterCondition extends PureComponent {

  handleDataChange(value) {
    if (this.props.tracking) {
      this.props.tracking.facetAdded({ ['condition']: value });
    }
    this.props.handleDataChange('condition', value);
  }

  render() {
    let { condition, params, position = '', intl: { formatMessage: t } } = this.props;
    let dashPosition = position ? '-' + position : '';
    return (
      <div className="search-filter condition">
        <div className="search-filter-group">
          <ToolSetRadioGroup>
            <ToolSetRadioItem
              id={`condition-any${dashPosition}`}
              name={`condition${dashPosition}`}
              value="any"
              checked={condition === 'any'}
              onChange={(value) => this.handleDataChange(value.target.value)}
            >
              <Link className="filter-condition-link" href={generateSearchPath({condition: 'any'}, params, true)}>{t(messages.all)}</Link>
            </ToolSetRadioItem>
            <ToolSetRadioItem
              id={`condition-new${dashPosition}`}
              name={`condition${dashPosition}`}
              value="new"
              checked={condition === 'new'}
              onChange={(value) => this.handleDataChange(value.target.value)}
            >
              <Link className="filter-condition-link" href={generateSearchPath({condition: 'new'}, params, true)}>
                {t(messages.new)}
              </Link>
            </ToolSetRadioItem>
            <ToolSetRadioItem
              id={`condition-used${dashPosition}`}
              name={`condition${dashPosition}`}
              value="used"
              checked={condition === 'used'}
              onChange={(value) => this.handleDataChange(value.target.value)}
            >
              <Link className="filter-condition-link" href={generateSearchPath({condition: 'used'}, params, true)}>
                { t(messages.used) }
              </Link>
            </ToolSetRadioItem>
          </ToolSetRadioGroup>
        </div>
      </div>
    );
  }
}

FilterCondition.propTypes = {
  condition: PropTypes.oneOf(['any', 'new', 'used']),
  handleDataChange: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  params: PropTypes.object,
  position: PropTypes.string,
  tracking: PropTypes.shape({
    facetAdded: PropTypes.func.isRequired,
  }),
};

export default injectIntl(FilterCondition);
